import BeginLogOut from 'actions/user/begin_log_out';

const RECENT_DISCONNECT_MS = 30000;

export default class UnauthorizedEventHandler {
  constructor(context) {
    this.context = context;
    this.disconnTimes = [];
  }

  handleDisconnect() {
    if (this._exceedsDisconnectLimit()) {
      this.disconnTimes = [];
      this.context.executeAction(BeginLogOut);
    }
  }

  handleUnauthorized() {
    this.context.executeAction(BeginLogOut);
  }

  _exceedsDisconnectLimit() {
    var now = Date.now();
    this.disconnTimes.push(now);
    this.disconnTimes = this.disconnTimes.slice(-5);
    var oldest = this.disconnTimes[0];
    var numEvents = this.disconnTimes.length;
    return numEvents === 5 && oldest > now - RECENT_DISCONNECT_MS;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/user/unauthorized_event_handler.js